import i18n from 'live/services/i18n'
import React, { useContext, useEffect, useState } from 'react'

import { DashboardContext } from 'live/context/dashboard'
import globalNotification from 'live/services/global-notification'

import api from '../api'
import { ParameterProps, ParameterSelectedProps } from '../types'
import ParametersEditionList from './ParametersEditionList'

export default () => {
    const [open, setOpen] = useState(false)
    const [newDashboardParameters, setNewDashboardParameters] = useState<ParameterSelectedProps[]>()
    const [savedDashboardParameters, setSavedDashboardParameters] = useState<String[]>([])
    const [defaultRunparameters, setDefaultRunParameters] = useState<ParameterProps[]>()
    const { state, params, ...context } = useContext(DashboardContext)
    const dashboardId = context?.dashboard?.id
    const mode = params?.mode

    const toggleModal = () => setOpen(!open)

    let assetLookupIsPresent = true
    if (!Array.isArray(state.currentFilterValues.asset_name_event_type)) {
        assetLookupIsPresent = false
    }

    const asset_name_event_type: string[] = assetLookupIsPresent ? state.currentFilterValues.asset_name_event_type : []
    if (asset_name_event_type.length !== 1) {
        console.warn('Run Parameter only work with one asset.')
        assetLookupIsPresent = false
    }
    const wellName = assetLookupIsPresent ? asset_name_event_type[0] : ''

    useEffect(() => {
        if (!wellName || !dashboardId) return

        const controller = new AbortController()
        const signal = controller.signal

        const dashboardParametersPromise = api.getDashboardParameters(signal, dashboardId)
        const dashboardParametersPromiseCallback = (data) => setSavedDashboardParameters(data?.parameters)

        const defaultParametersPromise = api.getDefaultParameters(signal)
        const defaultParametersPromiseCallback = (data) => setDefaultRunParameters(data?.parameters)

        const promises = [defaultParametersPromise, dashboardParametersPromise]
        const callbacks = [defaultParametersPromiseCallback, dashboardParametersPromiseCallback]

        Promise.all(promises).then((values) => {
            values.forEach((response, i) => {
                if (response.ok) {
                    response.json().then(data => callbacks[i](data))
                }
            });
        })

        return () => controller.abort()
    }, [assetLookupIsPresent, dashboardId, mode])

    function saveDashboardParameters(parameters) {
        const payload = parameters.filter(p => p.selected).map(p => p.key)
        api.saveDashboardParameters(dashboardId, payload)
        .then(response => {
            if (response.ok) {
                setSavedDashboardParameters(payload)
                globalNotification.success(i18n('Dashboard run-parameters configuration saved successfully.'))
            } else {
                globalNotification.error(i18n('Error saving dashboard run-parameters configuration.'))
                console.error(response)
            }
        })

        toggleModal()
    }

    useEffect(() => {
        if (defaultRunparameters != undefined && savedDashboardParameters != undefined) {
            const newDashParams = defaultRunparameters.map(e => ({ ...e, selected: !!(savedDashboardParameters.indexOf(e.key) >= 0) }))
            setNewDashboardParameters(newDashParams)
        }
    }, [defaultRunparameters, savedDashboardParameters])

    return !!assetLookupIsPresent && !!dashboardId && !!defaultRunparameters && !!newDashboardParameters ? (
        <li>
            <div className={'item-container'}>
                <span onClick={toggleModal}>
                    <i className="fa fa-cog"/>
                    <span className={'label-bold'}>Run Parameters</span>
                </span>
                {open ? (
                    <ParametersEditionList
                        toggleModal={toggleModal}
                        dashboardParameters={newDashboardParameters}
                        save={saveDashboardParameters}
                        dark={context.theme === 'dark'}
                    />
                ) : null}
            </div>
        </li>
    ) : null
}